/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import config from '@/const/config';
import { request } from '@/utils';
var API = config.API,
    switchApi = config.switchApi;
/**
 * 登录
 *
 * @export
 * @param {*} params { code, mobilePhone}
 * @returns
 */

export function login(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchpower.promotion.login'
  }), {
    ignoreLogin: true
  }).then(function (res) {
    return _objectSpread({
      mobile: params.mobilePhone,
      roleType: params.roleType,
      activityId: params.activityId,
      sourceId: params.sourceId || ''
    }, res.data);
  });
}
export function sendCode(params) {
  return request.post(API, _objectSpread({}, params, {
    versionFlag: 'new',
    action: 'user.account.sendCodeV2'
  }), {
    ignoreLogin: true
  }).then(function (res) {
    return res.data;
  });
}